import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AqsnPropertyDetailsService } from 'src/app/services/aqsn-property-details.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { Utils } from 'src/app/shared/utils';
import { FileUploadSourceType } from 'src/app/shared/enum-value';
import { LaunchDarklyUtil } from 'src/app/shared/launch-darkly-util';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-insurance-acquisition-property-details',
  templateUrl: './acquisition-insurance-property-details.component.html',
  styleUrl: './acquisition-insurance-property-details.component.css'
})
export class AcquisitionInsurancePropertyDetailsComponent {

  @Input() disableUpload: boolean = false;
  @Output() closeSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() propertyFileUploadDetailsFromSidebar: EventEmitter<object> = new EventEmitter<object>();

  propertyData: any = [];
  fileUploadData: any = [];
  cols: any[];
  data: any[] = [];
  systemDownFlagValue: boolean = false;

  constructor(private aqsnPropertyDetailsService: AqsnPropertyDetailsService,
    private router: Router,
    private apiService: ApiService,
    private utils: Utils,
    private fileUploadService: FileUploadService,
    private launchDarkly: LaunchDarklyUtil) {
  }

  ngOnInit() {
    this.aqsnPropertyDetailsService.AqsnPropertyDetailsServiceSub.subscribe((_propertyDetails: any) => {
      this.propertyData = ({
        propNme: _propertyDetails.propNme,
        complianceRate: _propertyDetails.complianceRate,
        coltRefNo: _propertyDetails.coltRefNo,
        dlNme: _propertyDetails.dlNme,
        dusDealId: _propertyDetails.dusDealId,
        aqsnDealId: _propertyDetails.aqsnDealId,
        aqsnDt: this.utils.getFormattedDate(_propertyDetails.aqsnDt),
        propInsrSubmtDt: this.utils.getFormattedDate(_propertyDetails.propInsrSubmtDt),
        insr: _propertyDetails.insr,
        reqdSubmDt: this.utils.getFormattedDate(_propertyDetails.reqdSubmtDt),
        insrFilename: this.convertFilenameToShortName(_propertyDetails.filenameINSR),
        insrSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.fileRcvdDttmINSR),
        propMstrNo: _propertyDetails.propMstrNo,
        //new fields 
        propAccord28Typ: _propertyDetails.propAccord28Typ,
        propAccord28TypFilename: this.convertFilenameToShortName(_propertyDetails.fileAccord28LocnAdr),
        propAccord28TypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propAccord28SmtdDttm),
        propAmrcnLandTtlAsscTyp: _propertyDetails.propAmrcnLandTtlAsscTyp,
        propAmrcnLandTtlAsscTypFilename: this.convertFilenameToShortName(_propertyDetails.fileAmrcnLandTtlAsscLocnAdr),
        propAmrcnLandTtlAsscTypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propAmrcnLandTtlAsscSmtdDttm),
        propFldAnlysWkshTyp: _propertyDetails.propFldAnlysWkshTyp,
        propFldAnlysWkshTypFilename: this.convertFilenameToShortName(_propertyDetails.fileFldAnlysWkshLocnAdr),
        propFldAnlysWkshTypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propFldAnlysWkshSmtdDttm),
        propNfipTyp: _propertyDetails.propNfipTyp,
        propNfipTypFilename: this.convertFilenameToShortName(_propertyDetails.fileNfipLocnAdr),
        propNfipTypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propNfipSmtdDttm),
        propPrvtOrExcsFldInsrCvrgTyp: _propertyDetails.propPrvtOrExcsFldInsrCvrgTyp,
        propPrvtOrExcsFldInsrCvrgTypFilename: this.convertFilenameToShortName(_propertyDetails.filePrvtOrExcsFldInsrCvrgLocnAdr),
        propPrvtOrExcsFldInsrCvrgTypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propPrvtOrExcsFldInsrCvrgSmtdDttm),
        propSpclFldHzrdDtmnFormTyp: _propertyDetails.propSpclFldHzrdDtmnFormTyp,
        propSpclFldHzrdDtmnFormTypFilename: this.convertFilenameToShortName(_propertyDetails.fileSpclFldHzrdDtmnFormLocnAdr),
        propSpclFldHzrdDtmnFormTypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propSpclFldHzrdDtmnFormSmtdDttm),
        propSchOfValTyp: _propertyDetails.propSchOfValTyp,
        propSchOfValTypFilename: this.convertFilenameToShortName(_propertyDetails.fileSchOfValLocnAdr),
        propSchOfValTypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propSchOfValSmtdDttm),
        propAccord25Typ: _propertyDetails.propAccord25Typ,
        propAccord25TypFilename: this.convertFilenameToShortName(_propertyDetails.fileAccord25LocnAdr),
        propAccord25TypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propAccord25SmtdDttm),
        propInsrTyp: _propertyDetails.propInsrTyp,
        propInsrTypFilename: this.convertFilenameToShortName(_propertyDetails.filePropInsrLocnAdr),
        propInsrTypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propInsrSmtdDttm),
        propLiabPlcyTyp: _propertyDetails.propLiabPlcyTyp,
        propLiabPlcyTypFilename: this.convertFilenameToShortName(_propertyDetails.fileLiabPlcyLocnAdr),
        propLiabPlcyTypSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.propLiabPlcySmtdDttm),
        floodInsrReqdFlag: _propertyDetails.floodInsrReqdFlag,
        transType: _propertyDetails.transType,
        ssn: _propertyDetails.ssn,
        propId: _propertyDetails.propId,
        cmmtNo: _propertyDetails.cmmtNo,
      });

      this.launchDarkly.launchDarklySub.subscribe((systemDownFlagValue) => {
        this.systemDownFlagValue = systemDownFlagValue;
      });

      this.loadTable();
    });


    this.cols = [
      { field: 'docType', header: 'Document Type', width: '125px' },
      { field: 'fileName', header: 'File Name', width: '125px' },
      { field: 'submittedOn', header: 'Submitted On', width: '125px' }
    ];
  }

  loadTable() {
    this.data = [];

    if (this.propertyData.insr && this.propertyData.insr.trim().length > 0) {
      this.data.push({ "docType": 'INS_' + this.propertyData.insr + '_', fileName: this.propertyData.insrFilename, 'submittedOn': this.propertyData.insrSubmittedOn });
    }

    if (this.propertyData.propAccord25Typ && this.propertyData.propAccord25Typ.trim().length > 0) {
      this.data.push({ "docType": 'A25_' + this.propertyData.propAccord25Typ + '_', fileName: this.propertyData.propAccord25TypFilename, 'submittedOn': this.propertyData.propAccord25TypSubmittedOn });
    }

    if (this.propertyData.propAccord28Typ && this.propertyData.propAccord28Typ.trim().length > 0) {
      this.data.push({ "docType": 'A28_' + this.propertyData.propAccord28Typ + '_', fileName: this.propertyData.propAccord28TypFilename, 'submittedOn': this.propertyData.propAccord28TypSubmittedOn });
    }

    if (this.propertyData.propAmrcnLandTtlAsscTyp && this.propertyData.propAmrcnLandTtlAsscTyp.trim().length > 0) {
      this.data.push({ "docType": 'ALTA_' + this.propertyData.propAmrcnLandTtlAsscTyp + '_', fileName: this.propertyData.propAmrcnLandTtlAsscTypFilename, 'submittedOn': this.propertyData.propAmrcnLandTtlAsscTypSubmittedOn });
    }

    if (this.propertyData.propFldAnlysWkshTyp && this.propertyData.propFldAnlysWkshTyp.trim().length > 0) {
      this.data.push({ "docType": 'FAW_' + this.propertyData.propFldAnlysWkshTyp + '_', fileName: this.propertyData.propFldAnlysWkshTypFilename, 'submittedOn': this.propertyData.propFldAnlysWkshTypSubmittedOn });
    }

    if (this.propertyData.propLiabPlcyTyp && this.propertyData.propLiabPlcyTyp.trim().length > 0) {
      this.data.push({ "docType": 'LIA_' + this.propertyData.propLiabPlcyTyp + '_', fileName: this.propertyData.propLiabPlcyTypFilename, 'submittedOn': this.propertyData.propLiabPlcyTypSubmittedOn });
    }
    if (this.propertyData.propNfipTyp && this.propertyData.propNfipTyp.trim().length > 0) {
      this.data.push({ "docType": 'NFIP_' + this.propertyData.propNfipTyp + '_', fileName: this.propertyData.propNfipTypFilename, 'submittedOn': this.propertyData.propNfipTypSubmittedOn });
    }

    if (this.propertyData.propPrvtOrExcsFldInsrCvrgTyp && this.propertyData.propPrvtOrExcsFldInsrCvrgTyp.trim().length > 0) { 
      this.data.push({ "docType": 'PFX_' + this.propertyData.propPrvtOrExcsFldInsrCvrgTyp + '_', fileName: this.propertyData.propPrvtOrExcsFldInsrCvrgTypFilename, 'submittedOn': this.propertyData.propPrvtOrExcsFldInsrCvrgTypSubmittedOn });
    }

    if (this.propertyData.propInsrTyp && this.propertyData.propInsrTyp.trim().length > 0) {
      this.data.push({ "docType": 'PROP_' + this.propertyData.propInsrTyp + '_', fileName: this.propertyData.propInsrTypFilename, 'submittedOn': this.propertyData.propInsrTypSubmittedOn });
    }

    if (this.propertyData.propSpclFldHzrdDtmnFormTyp && this.propertyData.propSpclFldHzrdDtmnFormTyp.trim().length > 0) {
      this.data.push({ "docType": 'SFHDF_' + this.propertyData.propSpclFldHzrdDtmnFormTyp + '_', fileName: this.propertyData.propSpclFldHzrdDtmnFormTypFilename, 'submittedOn': this.propertyData.propSpclFldHzrdDtmnFormTypSubmittedOn });
    }

    if (this.propertyData.propSchOfValTyp && this.propertyData.propSchOfValTyp.trim().length > 0) {
      this.data.push({ "docType": 'SOV_' + this.propertyData.propSchOfValTyp + '_', fileName: this.propertyData.propSchOfValTypFilename, 'submittedOn': this.propertyData.propSchOfValTypSubmittedOn });
    }

    if (!this.propertyData.insr) {
      this.data.push({ "docType": 'INS_' + 'null_', fileName: this.propertyData.insrFilename, 'submittedOn': this.propertyData.apprSubmittedOn });
    }

    this.launchDarkly.getLaunchDarklyShutDown(null, null)
  }

  showUploadFilesDialog(flag: boolean) {
    if (this.systemDownFlagValue) {
      this.apiService.shutDownApp = true;
      this.router.navigate([''], { skipLocationChange: true });
      return;
    }

    let selectedPropertyName = this.propertyData.propNme;
    let selectedDusDealId = this.propertyData.dusDealId;
    let selectedColtRefNo = this.propertyData.coltRefNo;
    let selectedAqsnDealId = this.propertyData.aqsnDealId;
    let selectedPropMstrNo = this.propertyData.propMstrNo;
    let selectedTransType = this.propertyData.transType;
    let selectedSSN = this.propertyData.ssn;
    let selectedPropId = this.propertyData.propId;
    let selectedCmmtNo = this.propertyData.cmmtNo;
    let selectedFloodInsrReqdFlag = this.propertyData.floodInsrReqdFlag;
    let showUploadFiles = flag;
    this.propertyFileUploadDetailsFromSidebar.emit({ selectedPropertyName, selectedDusDealId, selectedColtRefNo, selectedAqsnDealId, selectedPropMstrNo, selectedTransType, selectedSSN, selectedPropId, selectedCmmtNo, selectedFloodInsrReqdFlag, showUploadFiles });
    this.fileUploadService.setSource(FileUploadSourceType.AcquisitionPropertyDetails);
  }

  onClickCloseSidebar() {
    this.closeSidebar.emit(true);
  }

  // Convert "73a80411-5ae0-4a6d-8f6b-c42f99a4c35c___179053_ZON_Valid_CITI_DUSG_WithCRN.xml" to "179053_ZON_Valid_CITI_DUSG_WithCRN.xml"
  convertFilenameToShortName(filename: string) {
    if (filename) {
      let splitFilename = filename.split('___');
      if (splitFilename.length > 1) {
        return splitFilename[1];
      }
    }
    return filename;
  }
}
